export const Topics = {
	Main: "Main"
};
